import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 15,
    s: 0
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formattedTime = `${String(timeLeft.h).padStart(2, '0')}:${String(timeLeft.m).padStart(2, '0')}:${String(timeLeft.s).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-ink text-brand-paper shadow-md" data-id="element-312" data-mp="1bveryb8d5j3g">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-3 py-2 text-[11px] font-medium sm:gap-5 md:px-6 md:py-2.5 md:text-sm" data-id="element-313" data-mp="1gtgc6zhizogi">
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-goldLight" data-id="element-314" data-mp="27gj9ddqzwayz">
          <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-315" data-mp="22lwx78d3aedu">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-amber opacity-75" data-id="element-316" data-mp="1xpomq89u79d0" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-amber" data-id="element-317" data-mp="1srn2vl4l760h" />
          </span>
          <strong className="uppercase tracking-[0.12em]" data-id="element-318" data-mp="2qbhrgnep0y2f">Oferta de lanzamiento</strong>
        </div>
        <span className="h-4 w-px bg-brand-gold/45" aria-hidden="true" data-id="element-319" data-mp="2lcek2wb8qfra" />
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-paper" data-id="element-320" data-mp="2ge3ewyvw4tfe">
          <ClockIcon className="h-3.5 w-3.5 text-brand-goldLight" aria-hidden="true" data-id="element-321" data-mp="2ccrlei9wbo1x" />
          <span className="hidden sm:inline" data-id="element-322" data-mp="150hnf72k6fqp">Finaliza en</span>
          <span className="font-mono font-bold tabular-nums text-brand-goldLight" data-id="element-323" data-mp="14xwmqldzy5uj">
            {formattedTime}
          </span>
        </div>
        <a href="#pricing" className="rounded-full border border-brand-gold/50 bg-brand-gold px-2.5 py-1 text-[10px] font-bold text-brand-ink transition-colors hover:bg-brand-goldLight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-paper sm:px-3 sm:text-xs" data-id="element-324" data-mp="12gusfqlma3c1">
          VER PACK →
        </a>
      </div>
    </div>;
}